module.exports = __webpack_public_path__ + "img/no-image.957f5c1b.png";